import { Link, Outlet, useRouterState } from "@tanstack/react-router";

// The Chemistry Profile page hosts four sub-tabs sharing a QueryClient
// cache. Cross-tab links (e.g. "see the recipes that use this nutrient")
// land users on the right tab pre-filtered.

const TABS = [
  { to: "/chemistry-profile", label: "Water sources", exact: true },
  { to: "/chemistry-profile/nutrients", label: "Nutrients" },
  { to: "/chemistry-profile/plant-profiles", label: "Plant profiles" },
  { to: "/chemistry-profile/recipes", label: "Recipes" },
  { to: "/chemistry-profile/calibrations", label: "Calibrations" },
];

export function ChemistryProfileLayout() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">
          Chemistry profile
        </h1>
        <p className="text-sm text-muted-foreground">
          Your water sources, nutrient signatures, recipes, and recent
          calibrations.
        </p>
      </header>
      <nav className="flex gap-1 border-b">
        {TABS.map((t) => {
          const active = t.exact ? path === t.to : path.startsWith(t.to);
          return (
            <Link
              key={t.to}
              to={t.to}
              className={
                "px-3 py-2 text-sm transition-colors -mb-px border-b-2 " +
                (active
                  ? "border-foreground text-foreground"
                  : "border-transparent text-muted-foreground hover:text-foreground")
              }
            >
              {t.label}
            </Link>
          );
        })}
      </nav>
      <Outlet />
    </div>
  );
}
